module.exports = __webpack_public_path__ + "static/labyrinths-364a52d3aea91e926a23b3c9220d9c42.jpg";